import { ReactNode, useState } from 'react';
import styled from 'styled-components';
import Grid from '../Grid';
import Text from '../Text';

interface IProps {
  title: string;
  children: ReactNode;
}

const TooltipWrap = styled(Grid)`
  top: calc(100% + 5px);
  left: 50%;
  transform: translateX(-50%);
  width: max-content;
  white-space: pre-line;
  z-index: 1000;
  background-color: ${({ color }) => color};
  padding: 8px 12px;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);

  ::before {
    content: '';
    width: 0px;
    height: 0px;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);

    border-top: 5px solid transparent;
    border-bottom: 5px solid ${({ color }) => color};
    border-right: 5px solid transparent;
    border-left: 5px solid transparent;
  }
`;

function Tooltip({ title, children }: IProps) {
  const [active, setActive] = useState(false);

  return (
    <>
      <Grid
        display="inline-block"
        position="relative"
        cursor="pointer"
        onMouseOver={() => {
          setActive(true);
        }}
        onMouseOut={() => {
          setActive(false);
        }}
      >
        {children}
        {active && (
          <TooltipWrap display="inline-block" position="absolute" color="#616161">
            <Text color="white" fontSize="0.9rem">
              {title}
            </Text>
          </TooltipWrap>
        )}
      </Grid>
    </>
  );
}

export default Tooltip;
